<template>
  <div
    class="page-placeholder fill-height d-flex flex-column justify-content-center align-items-center"
  >
    <component :is="component" :config="config">
      <slot />
    </component>
  </div>
</template>

<script>
import PlaceholderNoResults from '@/components/basic/placeholders/PlaceholderNoResults.vue';
import PlaceholderEmptyState from '@/components/basic/placeholders/PlaceholderEmptyState.vue';

export default {
  name: 'PagePlaceholder',
  components: {
    PlaceholderNoResults,
    PlaceholderEmptyState,
  },
  computed: {
    showSearch: {
      get() {
        return !!this.config?.search;
      },
    },
    component() {
      return this.showSearch ? PlaceholderNoResults : PlaceholderEmptyState;
    },
  },
  props: {
    config: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
};
</script>

<style lang="less">
.page-placeholder {
  padding-bottom: 120px;
  padding-top: 30px;

  @media only screen and (max-width: 680px) {
    padding-bottom: 24px;
    padding-top: 24px;
  }
}
.base-placeholder {
  display: flex;
  flex-direction: column;
  padding: 32px;
  animation: fadeIn 0.3s ease;
  max-width: 620px;
  width: 100%;
  margin: auto;
  background: #fff;
  border-radius: @base-radius;
  box-shadow: @base-shadow2;

  &--empty {
    max-width: 680px;
  }

  @media only screen and (max-width: 680px) {
    margin: auto 12px;
    max-width: calc(100% - 24px);
    padding: 20px;
  }
}

.base-placeholder__icon {
  margin-bottom: 12px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  .v-icon {
    font-size: 48px;
  }

  @media only screen and (max-width: 680px) {
    width: 32px;
    height: 32px;

    .v-icon {
      font-size: 32px;
    }
  }
}

.base-placeholder__text {
  margin-bottom: 0;
}

.base-placeholder__actions {
  margin-top: 24px;
  display: flex;
}

.base-placeholder__action {
  min-width: 160px;
}

.base-placeholder__video {
  width: 100%;
  max-width: 620px;
  margin: 16px auto 24px;
  box-shadow: @base-shadow;
  background: var(--v-background-base);

  .player__wrapper {
    background: var(--v-background-base);
  }
}

.base-placeholder__video-ratio {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 = 9/6 */
  height: 0;
  overflow: hidden;
  border-radius: 8px;
  box-shadow: var(--v-shadow-2);
}

.base-placeholder__video-ratio iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
